import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=0dd39600&scoped=true&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaComponent.vue?vue&type=style&index=0&id=0dd39600&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd39600",
  null
  
)

export default component.exports